<template>
  <div id="parts-box">
    <v-layout align-center justify-center row v-if="propertiesDetails.length > 0" wrap>
      <v-flex sm6 xs11>
        <div class="headline head-page font-weight-bold">สรรพคุณ</div>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center row wrap>
      <v-flex mb-3 sm6 xs11>
        <v-layout
          align-center
          justify-center
          :key="index"
          row
          v-for="(propertiesDetail, index) in propertiesDetails"
          wrap
        >
          <v-flex py-1 xs12>
            <div class="body-2 font-weight-bold">
              {{ `${propertiesDetail.partsname || ''}${propertiesDetail.productname}` }}
              <span
                class="font-weight-light font-THSarabunNew"
              >{{ `มีสรรคุณ${propertiesDetail.properties || ''}` }}</span>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'parts-box',
  data() {
    return {}
  },
  computed: {
    productId() {
      return window.atob(this.$route.params.productId)
    },
    propertiesDetails() {
      return this.$store.getters['Properties/getAll']
    }
  },
  created() {
    this.$store.dispatch('Properties/fetch', this.productId)
  }
}
</script>

<style lang="scss" scoped></style>
